import { state } from "./State";

export const getEntities = () => {
  const keys = Array.from(new Set(state.entityKeys));
  return keys.map(key => state.entities[key]).flatMap(v => (v ? [v] : []));
};
